import logo from "assets/images/Cowva.svg"

export default function DesktopInvoiceCard() {
        return (
          <div className="h-full w-full flex flex-col gap-5 overflow-y-scroll items-center justify-center px-10">
            <div className=" w-full flex justify-between items-center">
              <h1 className="text-[24px] font-bold">Invoice Details</h1>
            </div>
            <div className="w-[65%] h-[100%] shadow-[0_20px_30px_-10px_rgba(0,0,0,0.3)] border-2 border-[#DDDDDD] flex items-center  justify-start flex-col  p-[30px] rounded-lg text-[14px] ">
              <div className="pb-4">
                <img src={logo} alt="" className="w-[120px] " />
              </div>
              <div className="w-full flex items-center justify-between  border-b border-[#DDDDDD] pb-3">
                <h1>Invoice #142</h1>
                <h1>PAID</h1>
              </div>
              <div className="w-full h-auto flex justify-start gap-8 items-center pt-6 text-[14px] ">
                <div className="flex items-start flex-col pr-16 border-e border-[#DDDDDD] ">
                  <h1 className="text-[#B0B0B0] pb-3">Invoiced to:</h1>
                  <p>Inocul8</p>
                  <p> Ajah </p>
                  <p>08160962414</p>
                </div>
                <div className="flex items-start flex-col">
                  <h1 className="text-[#B0B0B0] pb-3">Invoice Date</h1>
                  <p>February 19, 2024</p>
                  <p>08:59 PM</p>
                </div>
              </div>
              <div className="flex items-center justify-start w-full pt-7 pb-2">
                <p>Subscription Plan:</p>
              </div>
              <div className=" w-full flex items-center flex-col justify-center gap-[40px]">
                <div className="w-full h-40% flex justify-start items-center text-[14px] border-2 border-[#DDDDDD] rounded-lg">
                  <div className="w-[50%] flex border-r border-[#f1f1f1] flex-col items-start justify-start gap-5">
                    <div className="w-full h-[40%] flex border-b border-[#DDDDDD] flex-col items-start justify-center bg-[#DDDDDD] pl-5">
                      <h1>Description</h1>
                    </div>
                    <div className="w-full flex items-center justify-start pl-5 pb-6">
                      <h1>Premium</h1>
                    </div>
                  </div>
                  <div className="w-[50%] flex flex-col items-start justify-start gap-5">
                    <div className="w-full h-[40%] flex border-b border-[#DDDDDD] flex-col items-start justify-center bg-[#DDDDDD] pl-5">
                      <h1>Amount</h1>
                    </div>
                    <div className="w-full flex items-center justify-start pl-5 pb-6">
                      <h1>N77, 600</h1>
                    </div>
                  </div>
                </div>

                <div className="w-full   flex justify-start items-center text-[14px] border-2 border-[#DDDDDD] rounded-lg">
                  <div className="w-[50%] flex border-r border-[#f1f1f1] flex-col items-start justify-start gap-5">
                    <div className="w-full h-[40%] flex border-b border-[#DDDDDD] flex-col items-start justify-center bg-[#DDDDDD] pl-5">
                      <h1>Description</h1>
                    </div>
                    <div className="w-full flex items-center justify-start pl-5 pb-6">
                      <h1>Premium</h1>
                    </div>
                  </div>
                  <div className="w-[50%] flex border-r border-[#f1f1f1] flex-col items-start justify-start gap-5">
                    <div className="w-full h-[40%] flex border-b border-[#DDDDDD] flex-col items-start justify-center bg-[#DDDDDD] pl-5">
                      <h1>Description</h1>
                    </div>
                    <div className="w-full flex items-center justify-start pl-5 pb-6">
                      <h1>Premium</h1>
                    </div>
                  </div>
                  <div className="w-[50%] flex flex-col items-start justify-start gap-5">
                    <div className="w-full h-[40%] flex border-b border-[#DDDDDD] flex-col items-start justify-center bg-[#DDDDDD] pl-5">
                      <h1>Amount</h1>
                    </div>
                    <div className="w-full flex items-center justify-start pl-5 pb-6">
                      <h1>N77, 600</h1>
                    </div>
                  </div>
                </div>
              
              </div>
            </div>
          </div>
        ); 
    }